import { FC, useEffect } from 'react'
import { Alert } from 'antd'
import { Modal, PrimaryButton } from '../../ui'
import { QuestionCircle } from '../../../assets/icons'
import useRequest from "../../hooks/useRequest";
import {cancelPaymentReq} from "../config";
import { useTranslation } from 'react-i18next'
import {useCurrentUser} from "../../hooks/useCurrentUser";
import IAppState from 'store/states'
import { useSelector } from 'react-redux'
import {signBody} from "../../helpers";
import moment from 'moment'

import style from '../style.m.less'

interface IDeleteModal {
    isModalVisible: boolean
    setIsModalVisible: (value: boolean) => void
    id: number
    getAppeal: any
}

const DeleteModal: FC<IDeleteModal> = ({
    isModalVisible,
    setIsModalVisible,
    id,
    getAppeal
}) => {
    const { fetch: cancelPaymentRequest, isLoading } = useRequest(cancelPaymentReq)
    const { t } = useTranslation()
    const userInfo = useSelector((store: IAppState) => store.user)
    const { data } = userInfo
    const { isUserAdmin } = useCurrentUser()
    const isEmptySign = isUserAdmin && !data?.certificate_data
    const isSignExpired = isUserAdmin && !isEmptySign && !moment(data?.certificate_data.token_expiration).isAfter()

    const onDeleteHandler = async () => {
        const body = {}
        const { request_id, signature } = await signBody(body, data)
        cancelPaymentRequest({
            body,
            getParams: {
                id,
                request_id
            },
            config: {
                headers: {
                    Signature: signature
                }
            },
            onSuccess: () => {
                setIsModalVisible(false)
                getAppeal()
            }
        })
    }

    return (
        <Modal isModalVisible={isModalVisible} onCancel={() => setIsModalVisible(false)}>
            <div className={style.deleteModalWrapper}>
                <div className={style.deleteModalHeaderWrapper}>
                    <QuestionCircle />
                    <div className={style.deleteModalHeader}>
                        {'Отмена запроса на оплату'}
                    </div>
                </div>
            </div>
            <div className={style.deleteModalText}>
                {'Вы действительно хотите отменить запрос на оплату?'}
            </div>
            <>
                {(isEmptySign || isSignExpired) && (
                    <Alert
                        className={style.alert}
                        message={isEmptySign ? 'Не установлена ЭП' : 'Истек срок действия ЭП'}
                        type="error"
                        showIcon
                    />
                )}
            </>
            <div className={style.deleteModalButtonsBlock}>
                <PrimaryButton
                    onClick={() => setIsModalVisible(false)}
                    value={t('login.buttonCancel')}
                    isCancel
                    customStyle={{ padding: '8px 16px' }}
                />
                <PrimaryButton
                    onClick={onDeleteHandler}
                    isDelete={false}
                    value={isUserAdmin
                        ? t('detailedCard.confirmAndSign')
                        : t('detailedCard.confirm')
                    }
                    customStyle={{ marginLeft: '16px', padding: '8px 16px' }}
                    disabled={isLoading || isEmptySign || isSignExpired}
                />
            </div>
        </Modal>
    )
}

export default DeleteModal
